module.exports = "<div class=\"page-layout blank p-24\" fusePerfectScrollbar>\r\n\r\n    <!-- <h2>{{'SAMPLE.HELLO' | translate}}</h2> -->\r\n\r\n</div>\r\n"